// extracted by mini-css-extract-plugin
export default {"wrapper":"Y3-z","play":"Z3-z"};